import React from "react";
import { ToastContainer } from "react-toastify";
import LoadingLayer from "./components/LoadingLayer";
import UpgradesModal from "./components/UpgradesModal";
import MyModal from "./components/MyModal";
import PopupMessages from "./components/PopupMessages";

const MainLayout = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  return (
    <>
      <UpgradesModal />
      {/* <PopupMessages /> */}
      <LoadingLayer />
      <ToastContainer
        position="top-right"
        autoClose={50000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {children}
    </>
  );
};

export default MainLayout;
